/**
 * Employee Incident Export Service
 * HTTP operations for self-service incident export to file
 */
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';

/**
 * Service for employee incident export operations
 */
export class EmployeeIncidentExportService {
  /**
   * Export incidents to Excel file
   * GET /v{version}/employees/{employeeId}/attendances/incidents/file
   */
  async exportIncidents(
    employeeId: number,
    startDate: string,
    endDate: string,
    errorTypeId?: number | null,
    status?: string | null,
  ): Promise<ApiResponse<{ blob: Blob; filename: string }>> {
    const searchParams = new URLSearchParams();
    searchParams.append('startDate', startDate);
    searchParams.append('endDate', endDate);

    if (errorTypeId !== undefined && errorTypeId !== null) {
      searchParams.append('errorTypeId', String(errorTypeId));
    }

    if (status && status !== 'todos') {
      searchParams.append('status', status);
    }

    searchParams.append('format', 'excel');

    const endpoint = `${API_CONFIG.ENDPOINTS.EMPLOYEE_INCIDENTS.FILE(employeeId)}?${searchParams.toString()}`;
    return apiClient.downloadBlobWithFilename(endpoint, { method: 'GET' });
  }
}

export const employeeIncidentExportService = new EmployeeIncidentExportService();
